export const LICENSE_COMMERCIAL = 'COMMERCIAL';
export const LICENSE_ACADEMIC = 'ACADEMIC';
export const LICENSE_STARTER = 'STARTER';
export const LICENSE_OPENSOURCE = 'OPEN_SOURCE';
export const LICENSE_COMMUNITY = 'COMMUNITY';
export const LICENSE_DEVELOPER = 'DEVELOPER';
export const LICENSE_EVALUATION = 'EVALUATION';
export const LICENSE_FREE = 'FREE';
export const LICENSE_TRAINING = 'TRAINING';
export const LICENSE_UNIVERSITY = 'UNIVERSITY';
export const LICENSE_UNIVERSITY_PRICING_PLAN = 'UNIVERSITY_PRICING_PLAN';
export const LICENSE_SOCIAL_IMPACT = 'SOCIAL_IMPACT';
export const LICENSE_SOCIAL_IMPACT_GLOBAL_ACCESS = 'SOCIAL_IMPACT_GLOBAL_ACCESS';

export type LicenseType =
  | 'COMMERCIAL'
  | 'ACADEMIC'
  | 'STARTER'
  | 'OPEN_SOURCE'
  | 'COMMUNITY'
  | 'DEVELOPER'
  | 'EVALUATION'
  | 'FREE'
  | 'DEMONSTRATION'
  | 'FOUNDATION_FREE'
  | 'CLASSROOM'
  | 'SOCIAL_IMPACT'
  | 'SOCIAL_IMPACT_GLOBAL_ACCESS';
